import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { HalMark } from './HalMark';
import { ThemeToggle } from './ThemeToggle';
import { useAuth } from '../auth';

export function SiteNav() {
  const { profile, login, logout } = useAuth();
  // On the homepage the logo leads to its own story (/logo); everywhere
  // else it's the usual way home.
  const { pathname } = useLocation();
  const onHome = pathname === '/';

  return (
    <header className="site-nav">
      <div className="nav-brand">
        <Link to={onHome ? '/logo' : '/'} className="brand" title={onHome ? 'About the Cloudish logo' : 'Cloudish home'}>
          <Logo height={22} />
        </Link>
        <HalMark height={22} />
      </div>
      <div className="site-nav-links">
        <a href="/#features">Features</a>
        <a href="/#agents">For agents</a>
        <a href="/#pricing">Pricing</a>
        <a href="/#compare">Compare</a>
        {/* Named for the file agents use, but the page is for people: SKILL.md
            as HTML (pages/Doc.tsx), which names the markdown as its
            alternate for anything that wants that. */}
        <a href="/skill">SKILL.md</a>
        <Link to="/help">Help</Link>
        <ThemeToggle />
        {profile ? (
          <>
            <Link to="/claim" className="btn btn-sm">
              Dashboard
            </Link>
            <button type="button" className="btn btn-ghost btn-sm" onClick={() => logout()}>
              Sign out
            </button>
          </>
        ) : (
          <button type="button" className="btn btn-primary btn-sm" onClick={() => login('/claim')}>
            Sign up
          </button>
        )}
      </div>
    </header>
  );
}

export default SiteNav;
